import { ReactWebComponent } from '@app/utils/web-components'
import { lazy } from 'react'

const RootProviders = lazy(() => import('@app/components/AppProviders'))
const WorkflowsConflictBannerContainer = lazy(() => import('.'))

class WorkflowsConflictBannerWebComponent extends ReactWebComponent {
	override render() {
		return (
			<RootProviders>
				<WorkflowsConflictBannerContainer />
			</RootProviders>
		)
	}
}

customElements.define('workflows-conflict-banner', WorkflowsConflictBannerWebComponent)
